<template>

  <div>
    <v-card class="ma-1" outlined>

      <v-card-title>
        Media
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 271px">
        <v-carousel cycle hide-delimiters show-arrows-on-hover style="height: 100%">

          <template v-if="!hotel.images.length">
            <v-alert dark color="error">
              <v-row no-gutters align="center">
                <v-icon left>mdi-alert</v-icon>
                Acest hotel nu are poze.
              </v-row>
            </v-alert>
          </template>

          <template v-else>
            <v-carousel-item v-for="(image, index) in hotel.images" :key="index">
              <v-img :src="image.url" style="height: 247px" contain/>
            </v-carousel-item>
          </template>

        </v-carousel>
      </v-card-text>

    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary white--text" flat dark>
          <v-toolbar-title>Media</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-black ma-1">Adaugă poze</div>
            </v-col>
            <v-col cols="12">
              <v-file-input v-model="images" accept="image/*" label="Adaugă poze" @change="onImageChange($event)" multiple small-chips show-size outlined dense hide-details/>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-black ma-1">Galerie</div>
            </v-col>
            <v-col v-for="(image, index) in hotel.images" :key="`image_${index}`" class="d-flex child-flex" cols="2">
              <v-hover v-slot:default="{ hover }">
                <v-img :src="image.url" aspect-ratio="1" class="grey lighten-2 d-flex ma-1">
                  <v-row class="fill-height" align="center" justify="center">
                    <v-fade-transition>
                      <v-card v-if="hover" style="height: 100%; width: 100%; background-color: rgba(255,255,255,.8)">
                        <v-row align="center" justify="center" class="fill-height">
                          <v-btn fab depressed color="delete white--text" :loading="deleting_image" @click="destroy(image)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-row>
                      </v-card>
                    </v-fade-transition>
                  </v-row>
                </v-img>
              </v-hover>
            </v-col>

          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>

</template>

<script>

  import media_repository from "@/repositories/media-repository";

  export default {
    props: {
      hotel: Object,
    },

    data: () => ({
      dialog: false,
      images: null,
      deleting_image: false,
    }),

    methods: {
      onImageChange: function (files) {
        this.images_64 = [];
        for (let file of files) {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            this.images_64.push({data: fileReader.result});
          });
          fileReader.readAsDataURL(file);
        }
      },

      async save() {
        try {
          await media_repository.saveMedia(this.$route.params.hotel, 'hotels', {images: this.images_64});
          this.dialog = false;
          this.$emit('save');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.images = null;
          this.images_64 = null;
        }
      },

      cancel() {
        this.$emit('cancel');
        this.images = null;
        this.dialog = false;
      },

      async destroy(image) {
        try {
          this.deleting_image = true;
          await media_repository.deleteMedia(this.$route.params.hotel, 'hotels', image);
          const index = this.hotel.images.indexOf(image);
          if (index >= 0) this.hotel.images.splice(index, 1);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting_image = false;
        }
      }

    }
  }
</script>